import React from 'react';
import { Field } from 'redux-form';
import { Select, SelectItem } from '@topconagriculture/react-components';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { BillRunBatchPeriod } from '../../api';
const useStyles = makeStyles(() => ({
    field: {
        width: '100%',
        marginBottom: 10,
    },
}));
const BillingPeriodSelect = ({ name, label }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    return (React.createElement(Field, { className: classes.field, name: name, component: Select, label: label },
        React.createElement(SelectItem, { disabled: true }, t('profiling:company_settings.select_billing_period')),
        Object.values(BillRunBatchPeriod).map((value) => (React.createElement(SelectItem, { key: value, value: value }, t(`profiling:company_settings.billing_periods.${value}`))))));
};
export default BillingPeriodSelect;
//# sourceMappingURL=BillingPeriodSelect.js.map